import {APP_NAME} from '../brand';
import messages from './tag-messages.js';

// Because there are all brand names, it is unnecessary for them to be translatable.
export default [
    {tag: 'scratch', intlLabel: 'Scratch'},
    {tag: 'tsmod', intlLabel: APP_NAME},
    {tag: 'dash', intlLabel: 'Dash'},
    {tag: 'tw', intlLabel: 'TurboWarp'},
    {tag: 'other', intlLabel: 'Other'},
    {tag: 'gallerys', intlLabel: messages.gallerysInExtGallery}
]
